import { useState } from "react"
import { calcularEstadoCliente, COLORES_ESTADO } from "../../utils/estadoCliente"
import { BTN_GHOST, BTN_PRIMARY, formatFecha } from "../../utils/adminConstants"
import Modal from "./Modal"
import { calcularTotalPuntos, calcularDescuentoUSD } from "./CargarPuntos"

function BadgeEstadoAuto({ estado, label }) {
  const c = COLORES_ESTADO[estado] || COLORES_ESTADO.sin_viaje
  return <span style={{ display:"inline-block", padding:"3px 10px", borderRadius:"20px", fontSize:"0.75rem", fontWeight:700, background:c.bg, color:c.text, border:"1px solid "+c.text+"40", whiteSpace:"nowrap" }}>{label}</span>
}

function KpiCard({ clase, label, valor, sub, onClick }) {
  return(
    <div className={"admin__kpi-card "+clase} onClick={onClick} style={{ cursor:onClick?"pointer":"default",transition:"transform 0.15s" }}
      onMouseEnter={e=>{if(onClick)e.currentTarget.style.transform="translateY(-2px)"}}
      onMouseLeave={e=>{e.currentTarget.style.transform=""}}>
      <div className="admin__kpi-label">{label}</div>
      <div className="admin__kpi-valor">{valor}</div>
      <div className="admin__kpi-sub">{sub}{onClick&&<span style={{ marginLeft:"6px",fontSize:"0.7rem",opacity:0.6 }}>· ver</span>}</div>
    </div>
  )
}

function PanelEstados({ clientes, viajesPorCliente, onVerEstado }) {
  const conteos={sin_viaje:0,pendiente:0,checkin:0,en_viaje:0,completado:0}
  clientes.forEach(c=>{const e=calcularEstadoCliente(viajesPorCliente[c.id]||[]).estado;if(conteos[e]!==undefined)conteos[e]++})
  const items=[{estado:"en_viaje",label:"En viaje",color:"#10b981",icono:"🌍"},{estado:"checkin",label:"Check-in",color:"#f59e0b",icono:"🎒"},{estado:"pendiente",label:"Pendiente",color:"#3b82f6",icono:"⏳"},{estado:"completado",label:"Completado",color:"#8b5cf6",icono:"✅"},{estado:"sin_viaje",label:"Sin viaje",color:"#6b7280",icono:"👤"}]
  return(
    <div style={{ display:"flex",gap:"8px",flexWrap:"wrap",marginBottom:"24px" }}>
      {items.map(item=>(
        <button key={item.estado} onClick={()=>onVerEstado(item.estado,item.label)} style={{ display:"flex",alignItems:"center",gap:"8px",padding:"10px 16px",background:"#1a1a1a",border:"1px solid #2a2a2a",borderRadius:"10px",cursor:"pointer",fontFamily:"Inter, sans-serif",transition:"all 0.15s" }}
          onMouseEnter={e=>{e.currentTarget.style.borderColor=item.color;e.currentTarget.style.background=item.color+"15"}}
          onMouseLeave={e=>{e.currentTarget.style.borderColor="#2a2a2a";e.currentTarget.style.background="#1a1a1a"}}>
          <span>{item.icono}</span>
          <div style={{ textAlign:"left" }}>
            <div style={{ fontSize:"1.1rem",fontWeight:800,color:item.color,lineHeight:1 }}>{conteos[item.estado]}</div>
            <div style={{ fontSize:"0.7rem",color:"#6b7280",fontWeight:600 }}>{item.label}</div>
          </div>
        </button>
      ))}
    </div>
  )
}

function AlertasCumpleanos({ clientes, onIrACumpleanos }) {
  const hoy = new Date()
  hoy.setHours(0,0,0,0)

  function parsearNac(str) {
    if (!str) return null
    if (str.includes("/")) {
      const [d,m,y] = str.split("/")
      return new Date(Number(y), Number(m)-1, Number(d))
    }
    return new Date(str)
  }

  function diasParaCumpleHoy(str) {
    const nac = parsearNac(str)
    if (!nac || isNaN(nac)) return null
    const cumpleEsteAnio = new Date(hoy.getFullYear(), nac.getMonth(), nac.getDate())
    cumpleEsteAnio.setHours(0,0,0,0)
    return Math.ceil((cumpleEsteAnio - hoy) / (1000*60*60*24))
  }

  const cumpleHoy = clientes.filter(c => c.nacimiento && diasParaCumpleHoy(c.nacimiento) === 0)
  if (cumpleHoy.length === 0) return null

  return (
    <div style={{ display:"flex", flexDirection:"column", gap:"8px", marginBottom:"24px" }}>
      {cumpleHoy.map(c => (
        <div key={c.id} style={{ background:"rgba(201,168,76,0.08)", border:"1px solid #c9a84c", borderRadius:"12px", padding:"12px 16px", display:"flex", alignItems:"center", justifyContent:"space-between", gap:"12px" }}>
          <span style={{ color:"#c9a84c", fontWeight:700, fontSize:"0.875rem" }}>🎂 {c.nombre} {c.apellido} cumple años hoy</span>
          <button onClick={onIrACumpleanos} style={{ background:"none", border:"1px solid #c9a84c60", borderRadius:"6px", color:"#c9a84c", fontSize:"0.75rem", fontWeight:700, cursor:"pointer", padding:"4px 10px" }}>
            Ver en Cumpleaños
          </button>
        </div>
      ))}
    </div>
  )
}

function ModalClientesFiltrados({ titulo, clientes, viajesPorCliente, estadoFiltro, onCerrar, onCheckin }) {
  const filtrados=clientes.filter(c=>calcularEstadoCliente(viajesPorCliente[c.id]||[]).estado===estadoFiltro)
  return (
    <Modal titulo={titulo} subtitulo={filtrados.length+" clientes"} onCerrar={onCerrar} ancho="640px">
      <div style={{ display:"flex",flexDirection:"column",gap:"10px" }}>
        {filtrados.length===0?<div style={{ textAlign:"center",padding:"40px",color:"#4b5563" }}>No hay clientes en este estado.</div>:filtrados.map(c=>{
          const ea=calcularEstadoCliente(viajesPorCliente[c.id]||[]),v=ea.viaje
          return(
            <div key={c.id} style={{ background:"#1a1a1a",border:"1px solid #2a2a2a",borderRadius:"10px",padding:"14px 16px" }}>
              <div style={{ display:"flex",justifyContent:"space-between",alignItems:"flex-start" }}>
                <div>
                  <div style={{ fontWeight:700,color:"#e5e7eb",fontSize:"0.95rem" }}>{c.nombre} {c.apellido}</div>
                  <div style={{ fontSize:"0.8rem",color:"#6b7280",marginTop:"2px" }}>{c.telefono||"Sin telefono"} · {c.ciudad||"Sin ciudad"}</div>
                  {v&&<div style={{ fontSize:"0.8rem",color:"#9ca3af",marginTop:"4px" }}>✈️ {v.destino}{v.fecha_salida?` · ${formatFecha(v.fecha_salida)}`:""}{v.fecha_regreso?` → ${formatFecha(v.fecha_regreso)}`:""}</div>}
                  {v?.aerolinea&&<div style={{ fontSize:"0.75rem",color:"#4b5563",marginTop:"2px" }}>{v.aerolinea} · {v.pax} pax</div>}
                </div>
                <div style={{ display:"flex",flexDirection:"column",gap:"6px",alignItems:"flex-end" }}>
                  <BadgeEstadoAuto estado={ea.estado} label={ea.label}/>
                  {(ea.estado==="checkin"||ea.estado==="en_viaje")&&v&&!v.checkin_confirmado&&(
                    <button onClick={()=>onCheckin(c,v)} style={{ padding:"5px 12px",background:"#10b981",border:"none",borderRadius:"6px",color:"white",fontFamily:"Inter, sans-serif",fontWeight:700,fontSize:"0.75rem",cursor:"pointer",whiteSpace:"nowrap" }}>Confirmar check-in</button>
                  )}
                  {v?.checkin_confirmado&&<span style={{ fontSize:"0.75rem",color:"#10b981",fontWeight:600 }}>✓ Check-in</span>}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </Modal>
  )
}

function ModalConfirmarCheckin({ cliente, viaje, onConfirmar, onCerrar }) {
  const [confirmando, setConfirmando] = useState(false)

  async function handleConfirmar() {
    setConfirmando(true)
    await onConfirmar(cliente, viaje)
    setConfirmando(false)
    onCerrar()
  }

  return (
    <Modal titulo="Confirmar Check-in" subtitulo={`${cliente.nombre} ${cliente.apellido} — ${viaje.destino}`} onCerrar={onCerrar} ancho="480px">
      <div style={{ display:"flex", flexDirection:"column", gap:"14px" }}>
        <div style={{ background:"#1a1a1a", borderRadius:"10px", padding:"16px", display:"grid", gridTemplateColumns:"1fr 1fr", gap:"10px" }}>
          {[
            { label:"Destino",    valor: viaje.destino },
            { label:"Aerolínea",  valor: viaje.aerolinea },
            { label:"Fecha salida", valor: formatFecha(viaje.fecha_salida) },
            { label:"Pax",        valor: viaje.pax },
          ].filter(i=>i.valor).map(item=>(
            <div key={item.label}>
              <div style={{ fontSize:"0.7rem", color:"#4b5563", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.5px", marginBottom:"2px" }}>{item.label}</div>
              <div style={{ fontSize:"0.875rem", color:"#e5e7eb" }}>{item.valor}</div>
            </div>
          ))}
        </div>
        {(viaje.hora_vuelo_salida || viaje.codigo_vuelo_salida) && (
          <div style={{ background:"#0f2340", border:"1px solid #1e3a5f", borderRadius:"10px", padding:"14px", display:"grid", gridTemplateColumns:"1fr 1fr", gap:"10px" }}>
            {viaje.hora_vuelo_salida && (
              <div>
                <div style={{ fontSize:"0.7rem", color:"#4b5563", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.5px", marginBottom:"2px" }}>🛫 Hora de salida</div>
                <div style={{ fontSize:"0.95rem", color:"#e5e7eb", fontWeight:700 }}>{viaje.hora_vuelo_salida}</div>
              </div>
            )}
            {viaje.codigo_vuelo_salida && (
              <div>
                <div style={{ fontSize:"0.7rem", color:"#4b5563", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.5px", marginBottom:"2px" }}>✈️ Código de vuelo</div>
                <div style={{ fontSize:"0.95rem", color:"#e5e7eb", fontWeight:700 }}>{viaje.codigo_vuelo_salida}</div>
              </div>
            )}
          </div>
        )}
        <div style={{ display:"flex", gap:"8px" }}>
          <button onClick={onCerrar} style={{ ...BTN_GHOST, flex:1 }}>Cancelar</button>
          <button onClick={handleConfirmar} disabled={confirmando}
            style={{ ...BTN_PRIMARY, flex:2, background: confirmando ? "#1a1a1a" : "#10b981", color: confirmando ? "#6b7280" : "white" }}>
            {confirmando ? "Confirmando..." : "✓ Confirmar check-in"}
          </button>
        </div>
      </div>
    </Modal>
  )
}

function ModalConfirmarCheckout({ cliente, viaje, onConfirmar, onCerrar }) {
  const [confirmando, setConfirmando] = useState(false)

  async function handleConfirmar() {
    setConfirmando(true)
    await onConfirmar(cliente, viaje)
    setConfirmando(false)
    onCerrar()
  }

  return (
    <Modal titulo="Confirmar Check-out" subtitulo={`${cliente.nombre} ${cliente.apellido} — ${viaje.destino}`} onCerrar={onCerrar} ancho="480px">
      <div style={{ display:"flex", flexDirection:"column", gap:"14px" }}>
        <div style={{ background:"#1a1a1a", borderRadius:"10px", padding:"16px", display:"grid", gridTemplateColumns:"1fr 1fr", gap:"10px" }}>
          {[
            { label:"Destino",    valor: viaje.destino },
            { label:"Aerolínea",  valor: viaje.aerolinea },
            { label:"Fecha regreso", valor: formatFecha(viaje.fecha_regreso) },
            { label:"Pax",        valor: viaje.pax },
          ].filter(i=>i.valor).map(item=>(
            <div key={item.label}>
              <div style={{ fontSize:"0.7rem", color:"#4b5563", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.5px", marginBottom:"2px" }}>{item.label}</div>
              <div style={{ fontSize:"0.875rem", color:"#e5e7eb" }}>{item.valor}</div>
            </div>
          ))}
        </div>
        {(viaje.hora_vuelo_regreso || viaje.codigo_vuelo_regreso) && (
          <div style={{ background:"#0f2340", border:"1px solid #1e3a5f", borderRadius:"10px", padding:"14px", display:"grid", gridTemplateColumns:"1fr 1fr", gap:"10px" }}>
            {viaje.hora_vuelo_regreso && (
              <div>
                <div style={{ fontSize:"0.7rem", color:"#4b5563", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.5px", marginBottom:"2px" }}>🛬 Hora de regreso</div>
                <div style={{ fontSize:"0.95rem", color:"#e5e7eb", fontWeight:700 }}>{viaje.hora_vuelo_regreso}</div>
              </div>
            )}
            {viaje.codigo_vuelo_regreso && (
              <div>
                <div style={{ fontSize:"0.7rem", color:"#4b5563", fontWeight:700, textTransform:"uppercase", letterSpacing:"0.5px", marginBottom:"2px" }}>✈️ Código de vuelo</div>
                <div style={{ fontSize:"0.95rem", color:"#e5e7eb", fontWeight:700 }}>{viaje.codigo_vuelo_regreso}</div>
              </div>
            )}
          </div>
        )}
        <div style={{ display:"flex", gap:"8px" }}>
          <button onClick={onCerrar} style={{ ...BTN_GHOST, flex:1 }}>Cancelar</button>
          <button onClick={handleConfirmar} disabled={confirmando}
            style={{ ...BTN_PRIMARY, flex:2, background: confirmando ? "#1a1a1a" : "#8b5cf6", color: confirmando ? "#6b7280" : "white" }}>
            {confirmando ? "Confirmando..." : "✓ Confirmar check-out"}
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default function SeccionResumen({ clientes, viajes, viajesPorCliente, usuariosWeb, onAsignarPuntos, onCheckin, onCheckout, onIrACumpleanos }) {
  const hoy=new Date(),[modal,setModal]=useState(null)
  const [modalCheckin,setModalCheckin]=useState(null)
  const [modalCheckout,setModalCheckout]=useState(null)

  // ── Helpers de exportación ──────────────────────────────────────────
  const q = v => `"${String(v ?? "").replace(/"/g, '""')}"`

  function descargarCSV(nombre, filas) {
    const blob = new Blob(["\uFEFF" + filas.join("\n")], { type: "text/csv;charset=utf-8;" })
    const url  = URL.createObjectURL(blob)
    const a    = document.createElement("a")
    a.href     = url
    a.download = `${nombre}_${new Date().toISOString().slice(0, 10)}.csv`
    a.click()
    URL.revokeObjectURL(url)
  }

  function calcularEdad(nacStr) {
    if (!nacStr) return ""
    let nac
    if (nacStr.includes("/")) { const [d,m,y]=nacStr.split("/"); nac=new Date(+y,+m-1,+d) }
    else nac = new Date(nacStr)
    if (isNaN(nac)) return ""
    const h=new Date(), edad=h.getFullYear()-nac.getFullYear()
    return (h.getMonth()<nac.getMonth()||(h.getMonth()===nac.getMonth()&&h.getDate()<nac.getDate())) ? edad-1 : edad
  }

  function exportarVentas() {
    const clienteMap = {}
    clientes.forEach(c => { clienteMap[c.id] = c })

    const enc = ["Código Reserva","Cliente","Teléfono","Email","Ciudad","Destino 1","Destino 2","Aerolínea","Pax","Fecha Salida","Fecha Regreso","Hotel 1","Hotel 2","Estado","Check-in","Check-out"].join(",")

    const filas = viajes.map(v => {
      const c = clienteMap[v.cliente_id] || {}
      return [
        q(v.codigo_reserva),
        q((c.nombre||"") + " " + (c.apellido||"")),
        q(c.telefono),
        q(c.email),
        q(c.ciudad),
        q(v.destino1 || v.destino),
        q(v.destino2),
        q(v.aerolinea),
        q(v.pax),
        q(v.fecha_salida ? formatFecha(v.fecha_salida) : ""),
        q(v.fecha_regreso ? formatFecha(v.fecha_regreso) : ""),
        q(v.hotel1),
        q(v.hotel2),
        q(v.estado),
        q(v.checkin_confirmado  ? "Sí" : "No"),
        q(v.checkout_confirmado ? "Sí" : "No"),
      ].join(",")
    })

    descargarCSV("ventas_lowtravel", [enc, ...filas])
  }

  function exportarClientes() {
    const enc = ["Nombre","Apellido","Teléfono","Email","Ciudad","Nacimiento","Edad","DNI","CUIL","Origen","Puntos","USD Beneficio","Cant. Viajes","Destinos Visitados"].join(",")

    const filas = clientes.map(c => {
      const pts      = calcularTotalPuntos(c)
      const usd      = calcularDescuentoUSD(pts)
      const viajosC  = viajesPorCliente[c.id] || []
      const destinos = [...new Set(viajosC.flatMap(v => [v.destino1||v.destino, v.destino2].filter(Boolean)))].join(" | ")
      return [
        q(c.nombre),
        q(c.apellido),
        q(c.telefono),
        q(c.email),
        q(c.ciudad),
        q(c.nacimiento),
        q(calcularEdad(c.nacimiento)),
        q(c.dni),
        q(c.cuil),
        q(c.origen),
        pts,
        usd,
        viajosC.length,
        q(destinos),
      ].join(",")
    })

    //descargarClientes("clientes_lowtravel", [enc, ...filas])
    descargarCSV("clientes_lowtravel", [enc, ...filas])
  }
  const checkinsHoy=clientes.filter(c=>calcularEstadoCliente(viajesPorCliente[c.id]||[]).estado==="checkin")
  const enViaje=clientes.filter(c=>calcularEstadoCliente(viajesPorCliente[c.id]||[]).estado==="en_viaje")
  const proximosSiete=viajes.filter(v=>{const d=(new Date(v.fecha_salida)-hoy)/(1000*60*60*24);return d>=0&&d<=7&&v.estado!=="cancelado"})
  const totalCuentas       = usuariosWeb?.length || 0
  const cuentasVinculadas  = usuariosWeb?.filter(u => u.id_cliente_asociado).length || 0
  const cuentasSinVincular = totalCuentas - cuentasVinculadas
  const tasaVinculacion    = clientes.length > 0 ? Math.round((cuentasVinculadas / clientes.length) * 100) : 0

  function abrirCheckin(c,v){ setModal(null); setModalCheckin({cliente:c,viaje:v}) }

  return(
    <div>
      {modalCheckin&&<ModalConfirmarCheckin cliente={modalCheckin.cliente} viaje={modalCheckin.viaje} onConfirmar={onCheckin} onCerrar={()=>setModalCheckin(null)}/>}
      {modalCheckout&&<ModalConfirmarCheckout cliente={modalCheckout.cliente} viaje={modalCheckout.viaje} onConfirmar={onCheckout} onCerrar={()=>setModalCheckout(null)}/>}
      {modal&&<ModalClientesFiltrados titulo={modal.titulo} clientes={clientes} viajesPorCliente={viajesPorCliente} estadoFiltro={modal.estado} onCerrar={()=>setModal(null)} onCheckin={(c,v)=>abrirCheckin(c,v)}/>}
      <div className="admin__seccion-header">
        <div>
          <div className="admin__seccion-titulo">Resumen del dia</div>
          <div className="admin__seccion-sub">{hoy.toLocaleDateString("es-AR",{weekday:"long",year:"numeric",month:"long",day:"numeric"})}</div>
        </div>
        <div style={{ display:"flex", gap:"8px", flexShrink:0 }}>
          <button onClick={exportarVentas} style={{ padding:"9px 14px", background:"#1a1a1a", border:"1px solid #3a3a3a", borderRadius:"8px", color:"#9ca3af", fontFamily:"Inter, sans-serif", fontWeight:700, fontSize:"0.8rem", cursor:"pointer", whiteSpace:"nowrap" }}>
            📥 Ventas CSV
          </button>
          <button onClick={exportarClientes} style={{ padding:"9px 14px", background:"#1a1a1a", border:"1px solid #3a3a3a", borderRadius:"8px", color:"#9ca3af", fontFamily:"Inter, sans-serif", fontWeight:700, fontSize:"0.8rem", cursor:"pointer", whiteSpace:"nowrap" }}>
            📥 Clientes CSV
          </button>
        </div>
      </div>
      <AlertasCumpleanos clientes={clientes} onAsignarPuntos={onAsignarPuntos} onIrACumpleanos={onIrACumpleanos}/>
      <PanelEstados clientes={clientes} viajesPorCliente={viajesPorCliente} onVerEstado={(estado,label)=>setModal({estado,titulo:label})}/>
      <div className="admin__kpi-grid">
        <KpiCard clase="azul"   label="Check-ins activos" valor={checkinsHoy.length}    sub="proximas 48hs"       onClick={()=>setModal({estado:"checkin",titulo:"Check-in — proximas 48hs"})}/>
        <KpiCard clase="verde"  label="En viaje ahora"    valor={enViaje.length}         sub="clientes activos"    onClick={()=>setModal({estado:"en_viaje",titulo:"En viaje ahora"})}/>
        <KpiCard clase="dorado" label="Proximos 7 dias"   valor={proximosSiete.length}   sub="salidas programadas"/>
        <KpiCard clase="rojo"   label="Total clientes"    valor={clientes.length}         sub="en la base de datos"/>
        <KpiCard clase="azul"   label="Cuentas web"       valor={totalCuentas}             sub={`${cuentasVinculadas} vinculadas · ${cuentasSinVincular} pendientes`}/>
        <KpiCard clase="dorado" label="Tasa de vinculación" valor={`${tasaVinculacion}%`}  sub={`${cuentasVinculadas} de ${clientes.length} clientes`}/>
      </div>
      {checkinsHoy.length>0&&(<div className="admin__card">
        <div className="admin__card-header"><div className="admin__card-titulo">Check-ins proximas 48hs</div></div>
        <div className="admin__card-body">{checkinsHoy.map(c=>{const ea=calcularEstadoCliente(viajesPorCliente[c.id]||[]),v=ea.viaje;return(
          <div key={c.id} className="agenda-item hoy" style={{ justifyContent:"space-between" }}>
            <div style={{ display:"flex",alignItems:"center",gap:"12px" }}><div className="agenda-item__icono">🎒</div><div className="agenda-item__info"><div className="agenda-item__titulo">{c.nombre} {c.apellido} — {v?.destino}</div><div className="agenda-item__desc">{v?.aerolinea} · {v?.pax} pax{v?.fecha_salida?" · "+formatFecha(v.fecha_salida):""}</div></div></div>
            {!v?.checkin_confirmado?<button onClick={()=>abrirCheckin(c,v)} style={{ padding:"6px 14px",background:"#10b981",border:"none",borderRadius:"6px",color:"white",fontFamily:"Inter, sans-serif",fontWeight:700,fontSize:"0.8rem",cursor:"pointer",whiteSpace:"nowrap" }}>Confirmar check-in</button>:<span style={{ fontSize:"0.8rem",color:"#10b981",fontWeight:600 }}>✓ Confirmado</span>}
          </div>
        )})}</div>
      </div>)}
      {enViaje.length>0&&(<div className="admin__card">
        <div className="admin__card-header"><div className="admin__card-titulo">En viaje ahora</div></div>
        <div className="admin__card-body">{enViaje.map(c=>{const ea=calcularEstadoCliente(viajesPorCliente[c.id]||[]),v=ea.viaje;return(
          <div key={c.id} className="agenda-item proximo" style={{ justifyContent:"space-between" }}>
            <div style={{ display:"flex",alignItems:"center",gap:"12px" }}><div className="agenda-item__icono">🌍</div><div className="agenda-item__info"><div className="agenda-item__titulo">{c.nombre} {c.apellido} — {v?.destino}</div><div className="agenda-item__desc">Regreso: {v?.fecha_regreso?formatFecha(v.fecha_regreso):"—"} · {v?.aerolinea}</div></div></div>
            {!v?.checkout_confirmado?<button onClick={()=>setModalCheckout({cliente:c,viaje:v})} style={{ padding:"6px 14px",background:"#8b5cf6",border:"none",borderRadius:"6px",color:"white",fontFamily:"Inter, sans-serif",fontWeight:700,fontSize:"0.8rem",cursor:"pointer",whiteSpace:"nowrap" }}>Confirmar check-out</button>:<span style={{ fontSize:"0.8rem",color:"#8b5cf6",fontWeight:600 }}>✓ Check-out</span>}
          </div>
        )})}</div>
      </div>)}
    </div>
  )
}
